import request from '@/utils/request'
// import { debounce } from 'lodash'

// const DEBOUNCE_TIME = 500

export function getCategory () {
  return request({
    url: '/system/category/data',
    method: 'get'
  })
}

// export const getCategory = debounce(
//   function () {
//     return request({
//       url: '/system/category/data',
//       method: 'get'
//     })
//   }
//   , DEBOUNCE_TIME
// )
